module.exports = __webpack_public_path__ + "images/help-videos-preview-ical-4f6142dbbb35e8db200092bbdd9830b6.png";